import { render, staticRenderFns } from "./haoka2.vue?vue&type=template&id=0b497d4c&scoped=true&"
import script from "./haoka2.vue?vue&type=script&lang=js&"
export * from "./haoka2.vue?vue&type=script&lang=js&"
import style0 from "./haoka2.vue?vue&type=style&index=0&id=0b497d4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b497d4c",
  null
  
)

export default component.exports